import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../../common/breadcrumbs";
import { SWAL_SETTINGS } from "../../../../../utils/Constants";
import {
  globalLoader,
  handleServerValidations,
} from "../../../../../utils/commonfunction";
import * as subjectService from "../../../services/subject.services";
import * as Yup from "yup";
import CustomError from "../../../../../utils/customError";
import { useTranslation } from "react-i18next";

const SubjectEdit = () => {
  const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  const [showdefault, setShowDefault] = useState({});
  const [saveType, setSaveType] = useState("");

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Subjects", url: "/admin/cms/subjects/list/1" },
    { title: t("btn_edit"), url: "" },
  ];

  useEffect(() => {
    if (params.id) {
      subjectService
        .Details(params.id)
        .then((response) => {
          setShowDefault(response && response.data ? response.data : {});
        })
        .catch((error) => {
          console.log("error=====>", error);
        });
    }
  }, [params.id]);

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required("Subject name is required")
      .test("no-spaces", "Subject name is required", (value) => value && value.trim().length > 0),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: showdefault && showdefault.name ? showdefault.name : "",
      status: showdefault && showdefault.status ? showdefault.status : 1,
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      globalLoader(true);
      let formData = new FormData();
      formData.append("o_id", params.id);
      formData.append("name", values.name);
      formData.append("status", values.status);

      subjectService
        .Edit(formData)
        .then((response) => {
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            if (saveType !== "Save") {
              navigate(`/admin/cms/subjects/list/1`);
            }
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(error),
            ...SWAL_SETTINGS,
          });
          globalLoader(false);
          console.log("error ====> ", error);
        });
    },
  });

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={formik.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                <div>
                  <h6 className="main-content-label mb-3">Edit Subject</h6>
                </div>
                <div className="row row-sm">
                  <div className="col-md-12 text-center form-group">
                    <label htmlFor="name" className="text-left d-flex">
                      Subject Name
                      <span className="requirestar">*</span>
                    </label>
                    <input
                      name="name"
                      id="name"
                      type="text"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      className="form-control"
                      placeholder="Enter subject name"
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="name" form={formik} />
                    </span>
                  </div>

                  <div className="col-md-12 text-center form-group">
                    <label htmlFor="status" className="text-left d-flex">
                      Status
                    </label>
                    <div className="select-down-arrow">
                      <select
                        name="status"
                        id="status"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.status}
                        className="form-control"
                      >
                        <option value={1}>Active</option>
                        <option value={2}>Inactive</option>
                      </select>
                    </div>
                  </div>

                  <div className="mt-5">
                    <button
                      onClick={() => setSaveType("Save")}
                      className="btn btn-info mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_save")}
                    </button>
                    <button
                      onClick={() => setSaveType("")}
                      className="btn btn-success mr-2"
                      type="submit"
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("btn_save_exit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      onClick={() => navigate("/admin/cms/subjects/list/1")}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default SubjectEdit;
